import styled from 'styled-components';

export const ScrollContainer = styled.div`
   display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-y: auto;
  scrollbar-width: none;
  gap: 20px;
`;

export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom:15px;
  font-weight: 500;
  color: #323131;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #3F3F46; 
  padding:10px;
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 1.7; 
  font-weight: 400;
  color: #52525B; 
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom:15px;
`;

export const LastSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-bottom: 40px;
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  padding-bottom:25px;
`;

export const Logo = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 100%;
`;

export const TextContainer = styled.div`
  display: flex;
  max-width: 400px;
  font-size:14px;
  line-height:1.2;
  color: #52525B;
  text-align:left;
  white-space: pre-wrap;
`;

export const GalleryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  padding: 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const CoverImageWrapper = styled.div`
  position:relative;
  padding-bottom:160px;
`;

export const HomeCoverWrapper = styled.div`
    position: relative;
    padding-bottom:160px;
`;

export const HotelLogoWrapper = styled.div`
    width:250px;
    height:auto;
    position: absolute;
    margin-left:auto;
    margin-right:auto;
    left:0;
    right:0;
    bottom:0;
    display:flex;
    flex-direction:column;
    gap:10px;
    align-items:center;
    justify-content:center;
`;

export const HotelLogoContainer = styled.div`
    width:120px;
    height:120px;
    overflow:hidden;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:100%;
    border:solid #F4F4F5;
    padding: 5px;
    position: relative;
`;

export const LogoText = styled.p`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 5px;
    font-size: 12px;
    color: #52525B;
    background: rgba(255, 255, 255, 0.9);
`;

export const HotelName = styled.h3`
    font-size:18px;
    font-weight:500;
`;

export const Addres = styled.p` 
 font-size:12px;
 line-height:1.7;
 color: #52525B;
 text-align:center;
`;
export const SectionTitle = styled.h3`
    font-size:18px;
    font-weight:500;
    text-align:center;
    width:100%;
    margin-bottom:20px
`;
